/**
 Author - Saahil Madaan
 Git - https://bitbucket.org/techSavvySaahil/
 **/


import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import {colors} from "nxtconstants";


const propTypes = {
  description: PropTypes.string,
  title: PropTypes.string
};

const Confirmation = ({
  title,
  description
}) => (
  <Wrapper>
    <h1>{title}</h1>
    <img
      alt="sucess icon"
      loading="lazy"
      src="https://i.wlycdn.com/phoenix/v1/success-icon.svg"
    />
    <p>{description}</p>
  </Wrapper>
);


const Wrapper = styled.div`
  width: 95%;
  max-width: 800px;
  text-align: center;
  margin: 25px auto 50px;
  h1 {
    font-size: 3em;
    color: ${colors.primary};
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 2rem 0;
    font-family: Avenir-heavy;
    margin: 0em auto .2em;
    text-transform: uppercase;
    max-height: 120px;
    @media screen and (max-width:767px) {
      font-size: 2em;
      padding: 1em 0.5em 0.5em;
    }
  }
  p {
    font-size: 2rem;
    font-family: Avenir-Book;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 150px;
    @media screen and (max-width:767px) {
      padding: 1em;
    }
  }
  img {
    width: 150px;
    margin-bottom: 50px;
    max-height: 130px;
    @media screen and (max-width:767px) {
      width: 75px;
      margin-bottom: 30px;
    }
  }
`;

Confirmation.propTypes = propTypes;

export default Confirmation;
